import t, {init as initI18n} from '@/i18n/launcher';

initI18n();

export default function initDialogs(callback) {
  const modalDemoEndFirstHtml = `
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content alert-pop">
      <div class="modal-body">
        <div class="inner">
          <div class="icon-alert confirm">
            <div class="text">
              <p><strong>${t('demo.demoExamRoom.alert.row1')}</strong></p>
              <p>${t('demo.demoExamRoom.alert.row2')}<br /> ${t(
      'demo.demoExamRoom.alert.row2-1',
    )}</p>
            </div>
          </div>
          <div class="btn-box full">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal" aria-label="Close">${t(
              'common.cancel',
            )}</button>
            <button type="button" class="btn btn-dark" id="ok"> ${this.$t(
              'common.confirm',
            )}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
      `,
    modalDemoEndTwoHtml = `
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content alert-pop">
          <div class="modal-body">
            <div class="inner">
              <div class="icon-alert confirm">
                <div class="text">
                  <p><strong>${t('demo.demoExamRoom.alert.row3')}</strong></p>
                  <p>${t('demo.demoExamRoom.alert.row4')}</p>
                </div>
              </div>
              <div class="btn-box full-1">
                <button type="button" class="btn btn-dark" id="ok">${t(
                  'common.confirm',
                )}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  //  시험 종료 첫번째 모달
  const modalDemoEndFirstInit = document.createElement('div');
  modalDemoEndFirstInit.classList.add('modal');
  modalDemoEndFirstInit.classList.add('fade');
  modalDemoEndFirstInit.setAttribute('id', 'modal-end-first');
  modalDemoEndFirstInit.setAttribute('style', 'display:none');
  modalDemoEndFirstInit.innerHTML = modalDemoEndFirstHtml;

  this.modalInit = modalDemoEndFirstInit;
  modalDemoEndFirstInit.querySelector('#ok').addEventListener('click', () => {
    this.toggleModal('#modal-end-first', false);
    this.toggleModal('#modal-end-two', true);
    callback();
  });
  document.body.appendChild(modalDemoEndFirstInit);

  //  시험 종료 두번째 모달
  const modalDemoEndTwoInit = document.createElement('div');
  modalDemoEndTwoInit.classList.add('modal');
  modalDemoEndTwoInit.setAttribute('id', 'modal-end-two');
  modalDemoEndTwoInit.setAttribute('style', 'display:none;position:fixed');
  modalDemoEndTwoInit.innerHTML = modalDemoEndTwoHtml;

  this.modalInit = modalDemoEndTwoInit;
  modalDemoEndTwoInit.querySelector('#ok').addEventListener('click', () => {
    this.toggleModal('#modal-end-two', false);
    window.close();
  });
  document.body.appendChild(modalDemoEndTwoInit);
}
